import { useEffect, useState } from "react"

import { Flex, Typography } from "antd"
import cls from "classname"
import { t } from "i18next"
import { useLocation, useNavigate } from "react-router"

import ButtonComponent from "../../../Components/Button"
import Icon from "../../../Icon"

import "../styles.less"
import "./Sidebar.less"

const { Title, Text } = Typography

const tabsListAdmin = [
  {
    id: "enrollment",
    text: "Enrollment",
    icon: "piggy_bank",
    testId: "bs-sidebar-tab-enrollment"
  },
  {
    id: "auto-refund",
    text: "Auto-refund",
    icon: "currency",
    testId: "bs-sidebar-tab-auto-refund"
  },
  {
    id: "integrations",
    text: "Integrations",
    icon: "list_sparkle",
    testId: "bs-sidebar-tab-integrations"
  },
  {
    id: "receipts/all",
    text: "Receipt",
    icon: "receipt_bill",
    testId: "bs-sidebar-tab-receipt",
    subTabs: [
      { id: "receipts/all", text: "All", testId: "bs-sidebar-tab-receipt-all" },
      { id: "receipts/configure", text: "Configure", testId: "bs-sidebar-tab-receipt-configure" }
    ]
  },
  {
    id: "business_health/overview",
    text: "Business Health",
    icon: "centralhub",
    testId: "bs-sidebar-tab-business-health",
    subTabs: [
      {
        id: "business_health/overview",
        text: "Overview",
        testId: "bs-sidebar-tab-business-health-overview"
      },
      // {
      //   text: "Chargebacks",
      //   id: "business_health/chargebacks",
      //   markText: "SOON",
      //   isSoon: true,
      // },
      {
        text: "Monitoring",
        id: "business_health/monitoring",
        testId: "bs-sidebar-tab-business-health-monitoring"
      }
    ]
  },
  {
    id: "pricing",
    text: "Pricing",
    icon: "money",
    testId: "bs-sidebar-tab-pricing"
  },
  {
    id: "users",
    text: "Users",
    icon: "two_users",
    testId: "bs-sidebar-tab-users"
  },
  {
    id: "business",
    text: "Business",
    icon: "home",
    testId: "bs-sidebar-tab-business"
  }
]

const Sidebar = () => {
  const { pathname, search } = useLocation()
  const navigate = useNavigate()

  const tabs = tabsListAdmin

  function handleNavigate(subPage) {
    navigate({ pathname: `/business_settings/${subPage}`, search })
  }

  const getIsActive = (tabId, pathname, level) => {
    const cleanPathname = pathname.replace("/business_settings", "")
    const pathSegments = cleanPathname.split("/").filter(Boolean)

    return pathSegments?.[level] === tabId
  }

  return (
    <div className="sider bs-sidebar">
      <Title level={3} style={{ textAlign: "left", marginBottom: 24 }}>
        {t("Business settings")}
      </Title>

      <Text type="secondary" strong style={{ display: "inline-block", marginBottom: 8 }}>
        {t("Account")}
      </Text>

      <Flex gap={4} vertical={true}>
        {tabs.map((tab) => (
          <div key={tab?.id} style={{ width: "100%" }}>
            {tab?.subTabs ? (
              <CollapsableTabButton
                icon={<Icon type={tab.icon} /> ?? null}
                subTabs={tab.subTabs.map((subTab) => ({
                  ...subTab,
                  isActive: pathname.includes(subTab.id)
                }))}
                tabId={tab.id}
                text={tab.text}
                testId={tab.testId}
                isActive={getIsActive(tab.id, pathname, 0)}
                onClick={handleNavigate}
              />
            ) : (
              <TabButton
                onClick={() => handleNavigate(tab?.id)}
                icon={<Icon type={tab.icon} /> ?? null}
                active={getIsActive(tab.id, pathname, 0)}
                testId={tab.testId}
              >
                {t(tab.text)}
              </TabButton>
            )}
          </div>
        ))}
      </Flex>
    </div>
  )
}

const TabButton = ({ active, icon, children, onClick, disabled, classname, testId }) => {
  return (
    <ButtonComponent
      type="text"
      size="large"
      onClick={onClick}
      style={{ width: "100%" }}
      className={cls("flex", { active }, classname)}
      icon={icon}
      disabled={disabled}
      data-testid={testId}
    >
      {children}
    </ButtonComponent>
  )
}

const CollapsableTabButton = ({
  icon,
  onClick,
  disabled,
  text,
  subTabs,
  tabId,
  isActive,
  testId
}) => {
  const [isOpen, setIsOpen] = useState(true)
  const isActiveTab = subTabs.some((subTab) => subTab.isActive) || isActive

  useEffect(() => {
    if (isActiveTab) {
      setIsOpen(true)
    } else {
      setIsOpen(false)
    }
  }, [isActiveTab])

  return (
    <div className="collapsable-tab">
      <div className="collapsable-tab__header" style={{ marginBottom: "2px" }}>
        <TabButton
          active={isActiveTab}
          icon={icon}
          onClick={() => {
            setIsOpen((prev) => !prev)
            onClick(tabId)
          }}
          disabled={disabled}
          classname="collapsible-tab__button"
          testId={testId}
        >
          {text}
          <Icon
            type="chevron_down"
            style={{
              transition: "transform 0.2s",
              transform: isOpen ? "rotate(180deg)" : "rotate(0deg)",
              marginLeft: "auto"
            }}
          />
        </TabButton>
      </div>
      {isOpen && (
        <Flex vertical gap={4} style={{ paddingLeft: "28px" }}>
          {subTabs.map((subTab) => (
            <TabButton
              key={subTab.id}
              onClick={() => onClick(subTab.id)}
              disabled={subTab?.isSoon}
              active={subTab.isActive}
              classname="collapsible-tab__sub-button"
              testId={subTab.testId}
            >
              {subTab.text}
            </TabButton>
          ))}
        </Flex>
      )}
    </div>
  )
}

export default Sidebar
